<template lang="pug">
div
  div.text-lg.font-medium.neutral700--text.mt-8 {{ $t('Who_service_conducter') }}
  div.text-sm.neutral500--text {{ $t('Who_service_conducter_desc') }}

  div.d-flex.align-center
    v-spacer
    assign-provider-dropdown(:selectedProviders="providers" @added="attachProviders($event)")

  .provider-list
    v-data-table.mt-sm-4.pb-16(:headers="headers" :items="providers" item-key="id" :items-per-page="-1" :hide-default-header="providers.length === 0 && !isFetching" hide-default-footer disable-sort :loading="isFetching")
      template(v-slot:no-data)
        div.empty-box.mt-6.pa-8(align="center")
          v-avatar(color="neutral300" size="54")
            v-icon(color="neutral500" size="30") $yzi-users-02
          div.text-center.text-md.font-semibold.neutral700--text.mt-8 {{ $t('empty_assign_providers') }}
          div.text-center.text-sm.font-normal.neutral500--text.mt-1 {{ $t('empty_assign_providers_desc') }}
      template(v-slot:item.action="{ item, headers, index }")
        div(align="end")
          v-btn.ml-4(icon small @click="deleteProvider(item)")
            v-icon(color="neutral700" size="18") $yzi-trash-03

  div.d-flex.mt-5
    v-spacer
    v-btn.round-lg.heading-6.px-8(v-if="service" color="neutral700" dark depressed height="48" :loading="isLoading" @click="saveData") {{ $t('save') }}
    v-btn.round-lg.heading-6.px-8(v-else color="neutral700" dark depressed height="48" :loading="tempLoading" @click="addNewService") {{ $t('finish') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AssignProviderDropdown from '@/components/clinic/custom/AssignProviderDropdown.vue'

export default {
  name: 'ServiceProvider',
  components: { AssignProviderDropdown },
  data: () => ({
    isFetching: false,
    isLoading: false,
    searchText: '',
    providers: [],
    headers: [
      {
        text: 'Provider',
        value: 'name',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      },
      {
        text: 'Type',
        value: 'type',
        enable: true,
        class: 'text-xs font-bold neutral500--text text-uppercase'
      },
      {
        text: 'Action',
        value: 'action',
        enable: true,
        class: 'text-xs font-bold text-end neutral500--text text-uppercase'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      service: 'clinic/getService',
      tempLoading: 'clinic/getTempLoading'
    }),
    providerData () {
      if (!this.service) {
        return {
          providers: this.providers.map(m => m.id)
        }
      }
      return null
    }
  },
  mounted () {
    if (this.service) {
      this.setData(this.service)
    } else {
      this.$watch('providerData', {
        deep: true,
        handler (val) {
          this.$store.commit('clinic/updateTempService', val)
        } 
      })
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData (service) {
      this.providers = [...service.providers]
    },
    addNewService () {
      this.$emit('addNewService')
    },
    attachProviders (providers) {
      providers.forEach(o => {
        this.providers.push(o)
      })
    },
    deleteProvider (item) {
      this.providers = this.providers.filter(f => f.id !== item.id)
    },
    saveData () {
      this.isLoading = true
      const endpoint = `/clinics/${this.company.slug}/services/${this.service.id}`
      const data = { providers: this.providers.map(m => m.id) }
      this.$axios.patch(endpoint, data)
        .then(resp => {
          this.updateActivityLog(endpoint, data, resp, 'PATCH', this.service.id)
          this.$store.commit('clinic/setService', resp.data)
          this.showMessage(['success', this.$t('success_message.update_successful')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'service',
        activity: 'Update service (providers)',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
</style>